import React from "react";
import {
  ContacSupportCard,
  ContacSupportLink,
  ContacSupportList,
} from "./ContacSupport.styled";
import { ContacSupportContainer } from "./ContacSupport.styled";

const ContacSupport = () => {
  return (
    <ContacSupportContainer>
      <ContacSupportCard>
        <ContacSupportList>
          <h4 style={{ marginBlock: "10px" }}>Live Chat:</h4>
          <ContacSupportLink
            to={"https://tawk.to/645436d06a9aad4bc578f976"}
            target="_blank"
          >
            Support
          </ContacSupportLink>
        </ContacSupportList>
        <ContacSupportList>
          <h4 style={{ marginBlock: "10px" }}>Telegram ID:</h4>
          <ContacSupportLink
            to={"https://t.me/+ywg1LuVfJ75jYmE0"}
            target="_blank"
            rel="noreferrer"
          >
            Telegram
          </ContacSupportLink>
        </ContacSupportList>
        <ContacSupportList>
          <h4 style={{ marginBlock: "10px" }}>Whatsapp:</h4>
          <ContacSupportLink
            to={"https://api.whatsapp.com/send?phone=+14694314108"}
            target="_blank"
            rel="noreferrer"
          >
            Whatsapp
          </ContacSupportLink>
        </ContacSupportList>
        <ContacSupportList>
          <h4 style={{ marginBlock: "10px" }}>Email:</h4>
          <ContacSupportLink
            to={"mailto:contact@pubmining.org"}
            target="_blank"
          >
            Email
          </ContacSupportLink>
        </ContacSupportList>
      </ContacSupportCard>
    </ContacSupportContainer>
  );
};

export default ContacSupport;
